module.exports = __webpack_public_path__ + "static/certyfikat_9001_ang-37182f8ed32b125e2199059aec461a3a.pdf";